import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { FullScreenLoader } from "../Components/Loader";
import { getInfrakitProjects } from "../repositories/InfrakitRepository";
import { Button } from "@mui/material";
import { logOut } from "../utils/AxiosHandlers";
import TextField from "@mui/material/TextField";

export default function InfrakitProjects() {
  const [projects, setProjects] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("infrakitToken");
    const token = JSON.parse(authToken || "{}").accessToken;
    !token && navigate("/");

    const projectUuid = localStorage.getItem("infrakitProjectUuid");
    !!projectUuid && navigate("/connections");
  }, [navigate]);

  const fetchProjects = useCallback(() => {
    setIsLoading(true);
    getInfrakitProjects()
      .then((data) => {
        setProjects(data);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(fetchProjects, [fetchProjects]);

  const onSelectProject = (projectUuid: string) => {
    localStorage.setItem("infrakitProjectUuid", projectUuid);
    navigate("/connections");
  };

  const filteredProjects = projects.filter((project) =>
    project.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <div className="header-button-container">
        <div>
          <Button
            variant="contained"
            className="header-button"
            onClick={logOut}
          >
            Logout
          </Button>
        </div>
      </div>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <img
            src="https://infrakit.atlassian.net/s/tod1zk/b/4/4dfcd128b56e7dd5dce7882155d48d6a/_/jira-logo-scaled.png"
            alt="logo"
          />
          <TextField
            className="mt-3"
            label="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            size="small"
            fullWidth
          />
          <div className="list mt-0">
            {filteredProjects.map((e) => (
              <div
                key={e.uuid}
                className="list-item"
                onClick={() => onSelectProject(e.uuid)}
              >
                <div className="flex column gap-2">
                  <p className="title">{e.name}</p>
                </div>
              </div>
            ))}
            {isLoading && <FullScreenLoader isLoading />}
          </div>
        </Box>
      </Container>
    </div>
  );
}
